export default __webpack_public_path__ + "static/media/empty-image.3fb9ba8d.svg";